var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-wrapper",attrs:{"element-loading-text":"拼命加载中"}},[(_vm.check_type == 1)?_c('create-order'):(_vm.check_type == 2)?_c('close-order'):(_vm.check_type == 3)?_c('revise-order'):(_vm.check_type == 4)?_c('FillOrder'):_c('view-order')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37232d68","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/order/view.vue
// module id = 2404
// module chunks = 0